import gql from "graphql-tag";
const getUserQuery = gql(` 
query GetUsers($userid: String!) {
  getUsers(userid: $userid) {
    cognitoId
    mfaRequired
    mfaForced
    credits
    conduct
    notifications
    tos
    messages
    uuid
    avatar
    disableGenerateAvatar
    calcimage
    location
    aboutme
    displayname
    nickname
    unaliased
    subId
    userid
    created
    subType
    active
    VIP
    renewal
    subRenewal
    lastUpdate
  } 
}   
`)
export default getUserQuery;
